import $apiJSON from '../http/apiJSON'

// Shop API Service

export async function getShopProducts(params = {}) {
  return $apiJSON.get('shop/products/', { params })
}

export async function getShopProduct(slug) {
  return $apiJSON.get(`shop/products/${slug}/`)
}

export async function getShopCategories() {
  return $apiJSON.get('shop/categories/')
}

export async function getShopCart() {
  return $apiJSON.get('shop/cart/')
}

export async function addToCart(productSlug, quantity = 1) {
  return $apiJSON.post(`shop/products/${productSlug}/add-to-cart/`, { quantity })
}

export async function updateCartItem(itemId, quantity) {
  return $apiJSON.post('shop/cart/update_item/', { item_id: itemId, quantity })
}

export async function removeCartItem(itemId) {
  return $apiJSON.post('shop/cart/remove_item/', { item_id: itemId })
}

export async function clearCart() {
  return $apiJSON.post('shop/cart/clear/')
}

export async function createOrderFromCart(data) {
  return $apiJSON.post('shop/orders/create_from_cart/', data)
}

export async function getShopOrders() {
  return $apiJSON.get('shop/orders/')
}

export async function createShopOrder(data) {
  return $apiJSON.post('shop/orders/', data)
}

export async function getShopOrder(id) {
  return $apiJSON.get(`shop/orders/${id}/`)
}

export async function cancelShopOrder(id) {
  return $apiJSON.post(`shop/orders/${id}/cancel/`)
}

export async function rateProduct(slug, rating, review = '') {
  return $apiJSON.post(`shop/products/${slug}/rate/`, { rating, review })
}

export async function getProductReviews(slug) {
  return $apiJSON.get(`shop/products/${slug}/reviews/`)
}

export async function addProductReview(slug, reviewData) {
  return $apiJSON.post(`shop/products/${slug}/add_review/`, reviewData)
}

export async function likeProduct(slug) {
  return $apiJSON.post(`shop/products/${slug}/like/`)
}

export async function getProductComments(slug, page = 1) {
  return $apiJSON.get(`shop/products/${slug}/comments/`, { params: { page } })
}

export async function addProductComment(slug, data) {
  return $apiJSON.post(`shop/products/${slug}/add_comment/`, data)
}

export async function deleteProductComment(slug, commentId) {
  return $apiJSON.delete(`shop/products/${slug}/comments/${commentId}/delete/`)
}

// My Shop Management API
export async function getMyShopInfo() {
  return $apiJSON.get('shop/my-shop/info/')
}

export async function getMyShopProducts(params = {}) {
  return $apiJSON.get('shop/my-shop/products/', { params })
}

export async function createMyShopProduct(data) {
  return $apiJSON.post('shop/my-shop/create_product/', data)
}

export async function getMyShopProduct(productId) {
  return $apiJSON.get(`shop/my-shop/${productId}/product/`)
}

export async function updateMyShopProduct(productId, data) {
  return $apiJSON.put(`shop/my-shop/${productId}/product/`, data)
}

export async function deleteMyShopProduct(productId) {
  return $apiJSON.delete(`shop/my-shop/${productId}/delete_product/`)
}

export async function addMyShopProductImage(productId, formData) {
  return $apiJSON.post(`shop/my-shop/${productId}/add_image/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export async function deleteMyShopProductImage(productId, imageId) {
  return $apiJSON.delete(`shop/my-shop/${productId}/images/${imageId}/`)
}

export async function getMyShopOrders(params = {}) {
  return $apiJSON.get('shop/my-shop/orders/', { params })
}

export async function updateMyShopTelegram(data) {
  return $apiJSON.post('shop/my-shop/update_telegram/', data)
}

export async function updateMyShop(formData) {
  return $apiJSON.put('shop/my-shop/update_shop/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}